import { Loader2, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useEffect, useState } from 'react';

interface SignupProcessingProps {
  isProcessing: boolean;
  isComplete: boolean;
  message?: string;
}

export const SignupProcessing = ({ isProcessing, isComplete, message }: SignupProcessingProps) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (isComplete) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isComplete]);

  if (!isProcessing && !isComplete) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            {isComplete ? (
              <CheckCircle className="h-12 w-12 text-green-500" />
            ) : (
              <Loader2 className="h-12 w-12 animate-spin text-primary" />
            )}
          </div>
          <CardTitle>
            {isComplete ? 'Welcome to the team!' : 'Setting up your account...'}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted-foreground">
            {message || (isComplete 
              ? `Your account has been created successfully. Redirecting in ${countdown} seconds...`
              : 'Please wait while we set up your account and confirm your email.'
            )}
          </p>
          {isComplete && countdown === 0 && (
            <p className="text-sm text-muted-foreground mt-2">
              If you're not redirected automatically, please refresh the page.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
